// Catalogo prodotti per categoria.
// Per aggiungere prodotti: copia le foto in /public/prodotti/<categoria>/ e aggiungi una riga qui.
// price: usa null se non vuoi mostrare il prezzo.
export const catalog = {
  uomo: {
    title: "Uomo",
    subtitle:
      "Pigiami, homewear e completi per lui. Tessuti caldi e classici, dalle marche di fiducia.",
    hero: "/cat/uomo.jpg",
    items: [
      { img: "/prodotti/uomo/uomo-1.jpg", name: "Pigiama corto uomo", note: "Fantasia quadri", price: null },
      { img: "/prodotti/uomo/uomo-2.jpg", name: "Completo Navigare", note: "T-shirt & short lime", price: null },
      { img: "/prodotti/uomo/uomo-3.jpg", name: "Pigiama Navigare", note: "Serafino fantasia", price: "€ 29,90" },
      { img: "/prodotti/uomo/uomo-4.jpg", name: "Pigiama Oronero", note: "Serafino blu notte", price: null },
      { img: "/prodotti/uomo/uomo-5.jpg", name: "Pigiama Navigare", note: "Cardigan blu notte", price: null },
      { img: "/prodotti/uomo/uomo-6.jpg", name: "Completo Givova Homewear", note: "T-shirt & short beige", price: null },
      { img: "/prodotti/uomo/uomo-7.jpg", name: "Pigiama 100 Sbadigli", note: "Serafino 3 pezzi blu", price: null },
      { img: "/prodotti/uomo/uomo-8.jpg", name: "Pigiama 100 Sbadigli", note: "Fantasia 3 pezzi", price: null },
      { img: "/prodotti/uomo/uomo-9.jpg", name: "Completo IRGE", note: "Serafino azzurro Hit the Road", price: null },
    ],
  },
  donna: {
    title: "Donna",
    subtitle:
      "Pigiami, camicie da notte e vestaglie: eleganza e comodità per lei, in ogni stagione.",
    hero: "/cat/donna.jpg",
    items: [],
  },
  bimbi: {
    title: "Bimbi",
    subtitle:
      "Pigiamini morbidi e fantasie allegre per i più piccoli, dai neonati ai ragazzi.",
    hero: "/cat/bimbi.jpg",
    items: [],
  },
  "terza-eta": {
    title: "Terza Età",
    subtitle:
      "Camicie da notte e pigiami classici, comodi e facili da indossare. Anche taglie comode.",
    hero: "/cat/terza-eta.jpg",
    items: [],
  },
  intimo: {
    title: "Intimo",
    subtitle:
      "Un ampio reparto di intimo e calzetteria per tutta la famiglia, per ogni esigenza.",
    hero: "/cat/donna.jpg",
    items: [],
  },
};
